import { Injectable } from '@angular/core';
import hljs from 'highlight.js/lib/core';
import hljs_bash from 'highlight.js/lib/languages/bash';
import hljs_css from 'highlight.js/lib/languages/css';
import hljs_gherkin from 'highlight.js/lib/languages/gherkin';
import hljs_java from 'highlight.js/lib/languages/java';
import hljs_js from 'highlight.js/lib/languages/javascript';
import hljs_json from 'highlight.js/lib/languages/json';
import hljs_kotlin from 'highlight.js/lib/languages/kotlin';
import hljs_php from 'highlight.js/lib/languages/php';
import hljs_python from 'highlight.js/lib/languages/python';
import hljs_ts from 'highlight.js/lib/languages/typescript';
import hljs_xml from 'highlight.js/lib/languages/xml';
import hljs_xquery from 'highlight.js/lib/languages/xquery';
import { HighlightResult } from 'highlight.js';

import { ICodeHighlighter, ICodeHighlighterResponse } from '../../../shared/interfaces/code-highlighter.interface';

@Injectable({
  providedIn: 'root',
})
export class CodeHighlighterService implements ICodeHighlighter {
  private initialized: boolean = false;

  constructor() {
    this.initializeHljs();
  }

  private initializeHljs(): void {
    if (this.initialized) {
      return;
    }

    hljs.registerLanguage('bash', hljs_bash);
    hljs.registerLanguage('css', hljs_css);
    hljs.registerLanguage('gherkin', hljs_gherkin);
    hljs.registerLanguage('java', hljs_java);
    hljs.registerLanguage('javascript', hljs_js);
    hljs.registerLanguage('json', hljs_json);
    hljs.registerLanguage('kotlin', hljs_kotlin);
    hljs.registerLanguage('php', hljs_php);
    hljs.registerLanguage('python', hljs_python);
    hljs.registerLanguage('typescript', hljs_ts);
    hljs.registerLanguage('xml', hljs_xml);
    hljs.registerLanguage('xquery', hljs_xquery);

    this.initialized = true;
  }

  public highlight(code: string, requestedLanguage?: string): ICodeHighlighterResponse {
    // Test if the language is supported either in core or the additional loaded languages.
    const language: string = hljs.getLanguage(requestedLanguage) ? requestedLanguage : 'plaintext';

    try {
      const result: HighlightResult = hljs.highlight(code, { language });
      // As the language may not be the requested language this is returned with the response.
      return { code: result.value, language: result.language };
    } catch (error) {
      console.warn(`[CodeHighlighterService.highlight] Failed to highlight code with language "${language}":`, error);
      return { code, language };
    }
  }
}
